// extracted by mini-css-extract-plugin
export default {"tabs":"VcZ5rYP8EoLd2_1rlIFz"};